/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//Menu-JS


// Collection page filter
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.boost-pfs-filter-show-result').then((elm) => {
  elm.setAttribute('data-action', 'close-drawer');
  elm.setAttribute('data-drawer-id', 'collection-filter-drawer');
});

// product page tabs
const tabs = document.querySelector(".tabs");

if (tabs) {
  
  const tabHeaders = tabs.querySelectorAll(".tab-headers .tab-header");
  const tabContents = tabs.querySelectorAll(".tab-contents .tab-body");
  
  if (tabHeaders && tabContents) {
    tabHeaders.forEach(tabHeader => {
      tabHeader.addEventListener('click', e => {
        tabHeaders.forEach(tabHeader => tabHeader.classList.remove('active'));
        tabContents.forEach(tabContent => tabContent.classList.remove('open'));
        const dataTarget = tabs.querySelector(".tab-contents ."+tabHeader.dataset.target);
        if (dataTarget) {
          dataTarget.classList.add('open');
          tabHeader.classList.add('active');
          // Adjust height because of absolute elem
          tabs.querySelector(".tab-contents").style.height = dataTarget.offsetHeight + "px";
        }
      });
    });
    // initial height
    const dataTarget = tabs.querySelector(".tab-contents .tab-body.open");
    tabs.querySelector(".tab-contents").style.height = dataTarget.offsetHeight + "px";
  }
}

const mobileSearchContainer = document.querySelector("#SearchMobile");
const mobileSearchButton = document.querySelector("#SearchMobileTrigger");
const mobileSearchVisibleClass = "SearchMobile--visible";

if (mobileSearchContainer && mobileSearchButton) {
  const mobileSearchInput = mobileSearchContainer.querySelector(".SearchMobile__Form input");
  
  function closeMobileSearch() {
      mobileSearchInput.value = "";
      mobileSearchContainer.classList.remove(mobileSearchVisibleClass);
  }
  
  function openMobileSearch() {
      mobileSearchContainer.classList.add(mobileSearchVisibleClass);
      mobileSearchInput.focus();
  }
  
  mobileSearchButton.addEventListener('click', e => {
    mobileSearchContainer.classList.contains(mobileSearchVisibleClass) ? closeMobileSearch() : openMobileSearch();
  });
  mobileSearchContainer.querySelector("[data-action]").addEventListener('click', e => closeMobileSearch());
}


// TAB-JS
const DOM = {
    tabsNav: document.querySelector('.SectionHeader__TabList'),
    tabsNavItems: document.querySelectorAll('.TabList__Item'),
    panels: document.querySelectorAll('.TabPanel')
};

const setActiveItem = elem => {
DOM.tabsNavItems.forEach(el => {
    el.classList.remove('js-active');
});
elem.classList.add('js-active');

};

const findActiveItem = () => {
    let activeIndex = 0;
    for (let i = 0; i < DOM.tabsNavItems.length; i++) {
        if (DOM.tabsNavItems[i].classList.contains('js-active')) {
           activeIndex = i;
        break;
        };
    };
    return activeIndex;
};

const findActiveItemParams = activeItemIndex => {
    if(DOM.tabsNavItems[activeItemIndex] == undefined){
        return ;
    }
  
    const activeTab = DOM.tabsNavItems[activeItemIndex];
    const activeItemWidth = activeTab.offsetWidth - 1;
    const activeItemOffset_left = activeTab.offsetLeft;
    return [activeItemWidth, activeItemOffset_left];
};

const appendDecorationNav = () => {

    let decorationElem = document.createElement('div');
    decorationElem.classList.add('tabs__nav-decoration');
    decorationElem.classList.add('js-decoration');

    DOM.tabsNav.append(decorationElem);
    return decorationElem;
};

const styleDecorElem = (elem, decorWidth, decorOffset) => {
    elem.style.width = `${decorWidth}px`;
    elem.style.transform = `translateX(${decorOffset}px)`;
};

const findActivePanel = index => {
    return DOM.panels[index];
};

const setActivePanel = index => {
    DOM.panels.forEach(el => {
        el.classList.remove('js-active');
    });
    DOM.panels[index].classList.add('js-active');
};

window.addEventListener('load', () => {
    const activeItemIndex = findActiveItem();
    if(activeItemIndex != null){
        const activeItemParams = findActiveItemParams(activeItemIndex);
      if (activeItemParams) {
        const [decorWidth, decorOffset] = activeItemParams;
        const decorElem = appendDecorationNav();
        styleDecorElem(decorElem, decorWidth, decorOffset);
        findActivePanel(activeItemIndex);
        setActivePanel(activeItemIndex);
      }
    }
});

if(DOM.tabsNav){
    DOM.tabsNav.addEventListener('click', e => {
      const navElemClass = 'TabList__Item';
      if (e.target.classList.contains(navElemClass)) {
        const clickedTab = e.target;
        const activeItemIndex = Array.from(DOM.tabsNavItems).indexOf(clickedTab);
        setActiveItem(clickedTab);
        const activeItem = findActiveItem();
        const activeItemParams = findActiveItemParams(activeItemIndex);

        if (activeItemParams) {
          const [decorWidth, decorOffset] = activeItemParams;
          const decorElem = document.querySelector('.js-decoration');
          styleDecorElem(decorElem, decorWidth, decorOffset);
          findActivePanel(activeItemIndex);
          setActivePanel(activeItemIndex);
        }
      }
    })
}

//Slider_Show

window.addEventListener('resize', ()=>{
    let icon = document.querySelector('.icon-with-text');

    if (icon != undefined) {
     let withSliderShow = icon.offsetWidth;

        if(withSliderShow != undefined){
            if(withSliderShow <= 767){
                document.querySelector('.Iconwithtext').classList.add('SlideshowContainer');
            }else{
                document.querySelector('.Iconwithtext').classList.remove('SlideshowContainer');
            }
        }
    }
});

function reportWindowSize(){
    if(document.querySelector('.icon-with-text') == undefined){
        return ;
    }
    let withSliderShow = document.querySelector('.icon-with-text').offsetWidth;
    let innerSlider = document.querySelector('.Iconwithtext');
    let SliderMobile = document.querySelector('.icon-with-text .Iconwithtext');
    if(withSliderShow != undefined){
        if(withSliderShow <= 767){
            innerSlider.classList.add('SlideshowContainer');
        }else{
            innerSlider.classList.remove('SlideshowContainer');
        }
    }
    if(innerSlider.classList.contains('SlideshowContainer')){
        var itemShow = 1;
        let nextItem = document.querySelector('.btn_navigation .next');
        let prevItem = document.querySelector('.btn_navigation .prev');

        slideInit(itemShow);

        nextItem.addEventListener('click', (e)=>{
            e.preventDefault();
            slideInit( itemShow +=1 );
        });
        prevItem.addEventListener('click', (e)=>{
            e.preventDefault();
            slideInit( itemShow +=1 );
        });
        document.querySelectorAll('.SlideshowContainer .itemSlider').forEach((item)=>{
            item.addEventListener('mousedown', ()=>{
                console.log('has move');
                slideInit( itemShow +=1 );
            });
        });

        function slideInit(n){
            let itemSlider = document.querySelectorAll('.SlideshowContainer .itemSlider');

            if(itemSlider.length < n ) {
                itemShow = 1 ;
            }
            if(n < 1){
                itemShow = itemSlider.length
            }
            for (let i = 0; i < itemSlider.length; i++) {
                itemSlider[i].style.display = "none";
            }
            itemSlider[itemShow-1].style.display = "block";
        }

    }
}
reportWindowSize();
//==========================Notification
let btnCloseNofitication = document.querySelector('.NotificationPopup .Notification__Close');
let wrapperNofitication = document.querySelector('.freegift-notification');
if( btnCloseNofitication != null && btnCloseNofitication != undefined ){
    btnCloseNofitication.addEventListener('click', () => {
        wrapperNofitication.classList.add('HiddenNofitication');
    });
}
//==========================Add Event Scroll
let header = document.querySelector('.Header');
let pageContent = document.querySelector('.PageContainer');
const elementProductInfo = document.querySelector('.js-product-info');
window.onscroll = function(ev) {
    if ( window.scrollY >= 20) {
         if(header.classList.contains('header-sticky')){
             header.classList.add('show-border');
         }else{
             pageContent.classList.add('sticky-border');
         }
    }else{
        if(header.classList.contains('header-sticky')){
            header.classList.remove('show-border');
        }else{
            pageContent.classList.remove('sticky-border');
        }

    }

    //add class fixed on product info
    if (elementProductInfo != null) {
      if (window.scrollY > 300) {
        elementProductInfo.classList.add('fixed');
      }else{
        elementProductInfo.classList.remove('fixed');
      }
    }
};

// trigger open tab details
const linkDetail = document.querySelector(".ProductMeta__Description a");
const elementTabDetail = document.querySelectorAll(".Product__Tabs .Collapsible__Button");

if (linkDetail != null) {
  linkDetail.addEventListener('click', function(e){
    e.preventDefault();
    const checkTabOpen = elementTabDetail[0].getAttribute("aria-expanded");
    if (checkTabOpen == 'false') {
      window.scrollTo({
        top: elementTabDetail[0].offsetTop,
        behavior: 'smooth'
      });

      const checkIfScrollToIsFinished = setInterval(() => {
        if (window.scrollY === elementTabDetail[0].offsetTop) {
          elementTabDetail[0].click();
          clearInterval(checkIfScrollToIsFinished);
        }
      }, 100);
    }
  });
}

//add class to reduce margin bottom when
const sectionAlsoInCollection = document.querySelectorAll(".block-also-collection .Section");
const sectionYouMayAlsoLike = document.querySelector(".section--recommendations");
const sectionRecentlyViewed = document.querySelector(".section--recently-viewed");

if (sectionAlsoInCollection.length == 0 || (sectionAlsoInCollection.length == 0 && sectionYouMayAlsoLike.length == 0 && sectionRecentlyViewed.length == 0)) {
  document.querySelector(".Product[data-section-type='product']") ? document.querySelector(".Product[data-section-type='product']").classList.add('reduce-space') : null;
}
